import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeImageUrl',
})
export class SafeImageUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeUrl {
    let imageUrl = `${url}`;
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }
}
